import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
interface Item {
    code: string;
    name: string;
}

@Component({
    selector: 'clever-verpflegung',
    templateUrl: './verpflegung.component.html',
    styleUrls: ['./verpflegung.component.scss'],
    standalone: false
})
export class VerpflegungComponent implements OnInit {
    @Input() mode: string;
    @Input() partner: Partner;
    @Input() boardTypeList: Item[];
    isBrowser: boolean = false;
    ohneVerpflegung: boolean = false;
    frustuck: boolean = false;
    halbpension: boolean = false;
    vollpension: boolean = false;
    allinclusive: boolean = false;
    slicenbr: number = 5;
    selectedList: string[] = [];
    destroyRef = inject(DestroyRef);
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    selectohneVerpflegung() {
        this.ohneVerpflegung = !this.ohneVerpflegung;
        this.cdr.markForCheck();
        this.hotelService.boardTypeList({
            code: 'OV',
            name: 'Ohne Verpflegung',
        }, this.ohneVerpflegung, this.mode !== 'home');
    }

    selectfrustuck() {
        this.frustuck = !this.frustuck;
        this.cdr.markForCheck();
        this.hotelService.boardTypeList({
            code: 'UF',
            name: 'Frühstück',
        }, this.frustuck, this.mode !== 'home');
    }

    selecthalbpension() {
        this.halbpension = !this.halbpension;
        this.cdr.markForCheck();
        this.hotelService.boardTypeList({
            code: 'HP',
            name: 'Halbpension',
        }, this.halbpension, this.mode !== 'home');
    }

    selectvollpension() {
        this.vollpension = !this.vollpension;
        this.cdr.markForCheck();
        this.hotelService.boardTypeList({
            code: 'VP',
            name: 'Vollpension',
        }, this.vollpension, this.mode !== 'home');
    }

    selectallinclusive() {
        this.allinclusive = !this.allinclusive;
        this.cdr.markForCheck();
        this.hotelService.boardTypeList({
            code: 'AI',
            name: 'All Inclusive',
        }, this.allinclusive, this.mode !== 'home');
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: ParamFilters) => {
            this.ohneVerpflegung = false;
            this.frustuck = false;
            this.halbpension = false;
            this.vollpension = false;
            this.allinclusive = false;
            this.selectedList = [];
            this.cdr.markForCheck();
            for (let i = 0; i < filter?.boardTypeList?.length; i++) {
                this.selectedList.push(filter.boardTypeList[i].code);
                if (filter.boardTypeList[i].code === 'OV') {
                    this.ohneVerpflegung = true;
                    this.cdr.markForCheck();
                }
                if (filter.boardTypeList[i].code === 'UF') {
                    this.frustuck = true;
                    this.cdr.markForCheck();
                }
                if (filter.boardTypeList[i].code === 'HP') {
                    this.halbpension = true;
                    this.cdr.markForCheck();
                }
                if (filter.boardTypeList[i].code === 'VP') {
                    this.vollpension = true;
                    this.cdr.markForCheck();
                }
                if (filter.boardTypeList[i].code === 'AI') {
                    this.allinclusive = true;
                    this.cdr.markForCheck();
                }
            }
            this.cdr.markForCheck();
        });
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }

    showMore(all) {
        this.slicenbr = all;
    }

    selected(op): void {
        let push = true;
        if (this.selectedList.indexOf(op.code) >= 0) {
            push = false;
        }
        this.hotelService.boardTypeList(op, push, true);
        this.cdr.markForCheck();
    }
}

/*
{
            code: 'OV',
            name: 'Ohne Verpflegung',
            checked: false
        },
        {
            code: 'UF',
            name: 'Frühstück',
            checked: false
        },
        {
            code: 'HP',
            name: 'Halbpension',
            checked: false
        },
        {
            code: 'VP',
            name: 'Vollpension',
            checked: false
        },
        {
            code: 'AI',
            name: 'All Inclusive',
            checked: false
        }
*/
